// Branded book-cover placeholder shown until real cover art is supplied.
// If a book has an `image` field, render that instead.
import { BookOpen } from "lucide-react";

const readable = (hex) => (hex === "#FBEF14" || hex === "#00EE00" ? "#000000" : "#FFFFFF");

export default function BookCover({ book, className = "" }) {
  if (book.image) {
    return (
      <img
        src={book.image}
        alt={`Cover of ${book.shortTitle} by Dr. Maydine Alcid-Digsby`}
        loading="lazy"
        className={`w-full h-full object-contain bg-white ${className}`}
      />
    );
  }

  const bg = book.color || "#0000FF";
  const fg = readable(bg);
  return (
    <div
      className={`relative w-full h-full flex flex-col items-center justify-center text-center p-6 overflow-hidden ${className}`}
      style={{ backgroundColor: bg, color: fg }}
      role="img"
      aria-label={`Cover of ${book.shortTitle} by Dr. Maydine Alcid-Digsby`}
    >
      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.6) 0, transparent 40%), radial-gradient(circle at 80% 80%, rgba(0,0,0,0.25) 0, transparent 45%)",
        }}
      />
      <span
        className="relative uppercase tracking-widest text-[0.6rem] font-bold mb-4 opacity-90"
        style={{ color: fg }}
      >
        Digsby Early Learning
      </span>
      <BookOpen className="relative mb-4" size={40} strokeWidth={2.2} />
      <span className="relative font-heading font-bold text-xl sm:text-2xl leading-tight">
        {book.shortTitle}
      </span>
      <span className="relative mt-3 text-xs font-semibold opacity-90">
        {book.ageRange}
      </span>
    </div>
  );
}
